import { PANTERA, LORAX, KOALA } from 'HubStyleTokens/colors';
export const PARTNER_DIAMOND = PANTERA;
export const PARTNER_ELITE = LORAX;
export const PARTNER_GOLD = KOALA;
export const PARTNER_PLATINUM = KOALA;
export const PARTNER_SOLUTIONS = KOALA;
export const PROVIDER = KOALA;